

exports.__esModule = true;
exports.$xoSelectFiComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _auth = require('xo-models/src/auth');

var _index = require('xo-models/src/user/index');

var _index2 = require('xo-models/src/checkout/index');

var _choice = require('xo-models/src/choice');

require('js/lib/index');

require('xo-title/dist/directive');

require('xo-models/src/fi/index');

require('xo-models/src/fi/lib/fiMessages');

require('xo-models/src/fi/lib/fiApis');

require('xo-device-info/dist/index');

require('xo-member-components/src/review-paywith/directive');

require('xo-page-components/src/marketingOffers/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSelectFiComponent = exports.$xoSelectFiComponent = _squid.$Component.extend('$xoSelectFiComponent', {
    tag: 'xo-select-fi',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: true
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                auth: _auth.$AuthModel.instance().retrieve(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                variant: _choice.$ChoiceEligibility.instance().getVariant(this.props.token)
            };
        }
    },
    actions: {
        logout: function logout() {
            var _this = this;

            _logger.$logger.info('not_you_logout');

            if (window.xchild && _squid.$util.isIFrame()) {

                window.xchild.hide();

                var url = window.location.href.split('#')[0];
                var xprops = _extends({}, window.xprops);

                xprops.url = url;
                xprops.payment = function () {
                    return _this.models.auth.action('logout').then(function () {
                        return _this.props.token;
                    });
                };

                return window.ppxo.Checkout.renderPopupTo(window.top, xprops);
            }

            this.models.auth.action('logout').then(function () {
                _uiRouter.$state.go('checkout.login', {
                    source: 'NOT_YOU'
                });
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this2 = this;

            // make this better
            this.propValueObj = {
                propHeader: 'memberReview.propHead',
                propVal: 'memberReview.propVal',
                propImage: 'https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags.png'
            };

            this.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');

            this.personalizedBanner = {};
            this.setPersonalizedBanner = function (buyer_id) {
                _this2.personalizedBanner.show = true;
                _index.$UserPhotoModel.instance(buyer_id).retrieve({
                    params: {
                        'min_size': 45
                    },
                    success: function success(result) {
                        if (result && result.photo_url) {
                            _this2.personalizedBanner.imageUrl = result.photo_url;
                            _logger.$logger.info('personalized_banner_retrieve_success');
                        }
                    }
                });
            };
        },
        populate: function populate() {
            var _this3 = this;

            var checkoutSession = this.models.checkoutSession;
            var plan = checkoutSession.plan;

            // Personalization banner

            var merchantCountry = this.models.checkoutAppData.merchant.merchant_country;
            var personalizationEnabled = (0, _squid.$feature)('oneTouchPersonalization');

            if (this.models.auth.remembered && personalizationEnabled) {
                (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': merchantCountry }, 'xo_hermesnode_kmli_personalization_treatment').then(function (result) {
                    var treatmentName = result && result.treatment_name || '';
                    if (treatmentName) {
                        _logger.$logger.info('personalized_banner_enabled');
                        _this3.setPersonalizedBanner(_this3.models.auth.buyer_id);
                        // delete this.models.checkoutSession.message;
                    } else {
                        _this3.personalizedBanner.show = false;
                        delete _this3.models.auth.rtExchanged;
                        _logger.$logger.info('personalized_banner_disabled');
                    }
                });
            } else {
                _logger.$logger.info('personalized_banner_ineligible', {
                    'isFeature': personalizationEnabled,
                    'isOneTouch': this.models.auth.remembered
                });
                if (this.models.auth.rtExchanged) {
                    delete this.models.auth.rtExchanged;
                }
            }

            this.showNotYou = this.models.auth.is_auth_api_call && _squid.$util.param('source') !== 'consumerApp' && !_squid.$util.param('redirectToHermesOn3DSDecline');

            this.formattedNameInformal = (0, _squid.formatNameInformal)({
                first_name: this.models.auth.first_name,
                last_name: this.models.auth.last_name
            }) || this.models.auth.email;

            // Selected FI radio buttons
            this.selectedmethod = {
                index: 0,
                planId: plan.id
            };

            this.getSortedPlans = function () {
                return checkoutSession.getPlanList();
            };

            // Check if is variant where preferred can be set
            var preferredFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.preferredCheckbox || [];

            this.preferredFiVariant = preferredFiVariants.indexOf(this.models.variant) > -1;

            var updateFS = function updateFS() {
                if (checkoutSession.get('plan.sources')[0].id !== _this3.selectedmethod.planId) {

                    return checkoutSession.fundingOptions.action('select', {
                        data: {
                            planId: _this3.selectedmethod.planId
                        },
                        success: function success(result) {
                            checkoutSession.populate(result);

                            return result;
                        },
                        contingencies: {
                            NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, result) {
                                if (result && result.resolution) {
                                    var card = result.resolution.data;

                                    if (card.fundingId && card.fi && card.fi.type) {
                                        _this3.cardModel.id = card.fundingId;
                                        _this3.cardModel.card = new _index2.$CardModel({
                                            number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                                            type: card.fi.type.toUpperCase(),
                                            productType: card.fi.productType
                                        });
                                    }
                                }

                                _uiRouter.$state.go('.confirmUpop');
                            },

                            DEFAULT: function DEFAULT() {
                                // Error message for failures
                                _uiRouter.$state.go('checkout.review');
                            }
                        }
                    });
                } else {
                    return _bluebird2['default'].resolve();
                }
            };

            this['continue'] = function (evt) {
                return updateFS().then(function (result) {
                    // Decide routing after update

                    if (result) {
                        // Update the installments to support the user selecting a card that does not support installments.
                        _this3.models.checkoutSession.installments = result.installments;
                    }

                    // If paypal credit, check for installments and redirect if needed
                    if (_this3.models.checkoutSession.plan.paypal_credit && _this3.models.checkoutSession.creditOffer) {
                        var token = _this3.props.token;
                        var installments = _index2.$InstallmentOptionsModel.instance(token);
                        var data = {
                            isMemberCredit: true
                        };

                        return (0, _squid.$populate)(data, {
                            payee: _index2.$CheckoutPayeeModel.instance(token),
                            checkoutCart: _index2.$CheckoutCartModel.instance(token),
                            checkoutAppData: _this3.models.checkoutAppData
                        }).then(function () {
                            return installments.save({
                                cache: true, // Cache between here and $ChoiceEligibilityModel
                                data: data,
                                success: function success(installmentResult) {
                                    var offers = installmentResult.installments && installmentResult.installments[0];
                                    var hasInstallments = offers && offers.installment_options && offers.installment_options.length;

                                    return hasInstallments;
                                },
                                contingencies: {
                                    DEFAULT: function DEFAULT() {
                                        // Assume is eligible if contingency
                                        return false;
                                    }
                                },
                                error: function error() {
                                    return false;
                                }
                            });
                        }).then(function (hasInstallments) {
                            if (hasInstallments) {
                                return _uiRouter.$state.go('checkout.chooseCreditOffer');
                            } else {
                                return _uiRouter.$state.go('checkout.review');
                            }
                        });
                    } else {
                        return _uiRouter.$state.go('checkout.review');
                    }
                });
            };
        }
    }
});

angular.value("$xoSelectFiComponent", $xoSelectFiComponent);
_squid.$Component;

_squid.$populate;

_squid.$config;

_squid.$feature;

_squid.$integration;

_squid.$pxp;

_squid.formatNameInformal;

_squid.$util;

_uiRouter.$state;

_logger.$logger;

_auth.$AuthModel;

_index.$UserPhotoModel;

_index2.$CheckoutSessionModel;

_index2.$CardModel;

_index2.$InstallmentOptionsModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutAppDataModel;

_choice.$ChoiceEligibility;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-select-fi/directive.js
// module id = ./pages/xo-select-fi/directive.js
// module chunks = 1